import React from "react";
import { apiCall, displayLog } from "../common/common";

const DashboardContext = React.createContext();

const rootReducer = (state, action) => {
  switch (action.type) {

    case "GET_TOTAL_USERS":
      return {
        isLoaded: true,
        totalUsers: action.payload,
      };

    default:
      return {
        ...state
      };
  }
};

const DashboardProvider = ({ children }) => {


  const [totalUsers, setTotalUsers] = React.useReducer(rootReducer, {
    isLoaded: false,
    totalUsers: []
  });


  return (
    <DashboardContext.Provider value={{ totalUsers, setTotalUsers }}>
      {children}
    </DashboardContext.Provider>
  );
};

const useDashboardState = () => {
  const context = React.useContext(DashboardContext);
  return context;
};


//API call to get Total users on the love online platform
export async function getTotalUsersOnPlatform(dispatch) {

  let res = await apiCall('GET', 'GET_TOTAL_USERS', '/admin/dashboard', {}, {}, {}, dispatch)
  if (res && res.data) {
    if (res.data.code === 0) {
      displayLog(0, res.data.message)
    }
    else {
      dispatch({ type: "GET_TOTAL_USERS", payload: res.data });
    }

  }
}


export { DashboardProvider, DashboardContext, useDashboardState };